/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import SuccessMsg from "../../components/successMsg";

import Label from "../../components/label";

const ChangePinForm = props => {
    const formik = useFormik({
        initialValues: {
            oldPin: "",
            newPin: "",
        },
        validationSchema: Yup.object({
            oldPin: Yup.string()
                .matches(/^[0-9]{4}$/, "Pin should be 4 number")
                .required("Please enter pin numbers"),
            newPin: Yup.string()
                .matches(/^[0-9]{4}$/, "Pin should be 4 number")
                .required("Please enter pin numbers"),
        }),
        onSubmit: values => {
            props.onFormSubmit(values);
        }
    });
    return (
        <form className="row" onSubmit={formik.handleSubmit}>
            <div className="col-sm-6 offset-sm-3 mt-1">
                <Label
                    title="Old Pin"
                    className="gray text-left w-100 mt-2 small"
                    required={true}
                />
                <ICInput
                    id="oldPin"
                    name="oldPin"
                    type="password"
                    label=""
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.oldPin}
                    error={
                        formik.touched.oldPin && formik.errors.oldPin
                            ? true
                            : false
                    }
                    helperText={
                        formik.touched.oldPin && formik.errors.oldPin
                            ? formik.errors.oldPin
                            : ""
                    }
                />
            </div>

            <div className="col-sm-6 offset-sm-3 mt-3">
                <Label
                    title="New Pin"
                    className="gray text-left w-100 mt-2 small"
                    required={true}
                />
                <ICInput
                    id="newPin"
                    name="newPin"
                    type="password"
                    label=""
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.newPin}
                    error={
                        formik.touched.newPin && formik.errors.newPin
                            ? true
                            : false
                    }
                    helperText={
                        formik.touched.newPin && formik.errors.newPin
                            ? formik.errors.newPin
                            : ""
                    }
                />
            </div>

            <div className="col-sm-6 text-center mt-3">
                <Button className="mt-2" title="Submit" type="submit" />
            </div>
            <div className="col-sm-6 text-center mt-3">
                <Button className="mt-2 red" title="Close" type="button" onClick={props.closeModal} />
            </div>
        </form>
    );
};

export default ChangePinForm;

ChangePinForm.defaultProps = {
    serverErrorMsg: "",
    successMsg: ""
};

ChangePinForm.propTypes = {
    onFormSubmit: PropTypes.func,
    serverErrorMsg: PropTypes.string,
    successMsg: PropTypes.string
};
